import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoubleCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"double-checkmark-2"} maskId="square-filled-radius-0-stroke-1-IconDoubleCheckmark2"><path d="M19.1992 4.39453L7.54004 20.2129L7.13477 19.8926L0.797852 14.8955L1.41699 14.1104L7.34766 18.7871L18.3945 3.80078L19.1992 4.39453Z" fill="currentColor"/><path d="M23.1992 4.39453L11.5498 20.1992L10.7451 19.6055L22.3945 3.80078L23.1992 4.39453Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDoubleCheckmark2;
